module.exports = "<div class=ring><div class=circle v-el:circle></div><slot></slot></div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ring.vue
 ** module id = 225
 ** module chunks = 0
 **/